import Router from './navigation/Router';

function Root() {
  return <Router />;
}

export default Root;
